module.exports = __webpack_public_path__ + "media/images/logo-header-2c7de5cbe65d7ec949473092175a7540.png";